export const EVENT_CONFIRMATION_DISMISS_INTERVAL_MINUTES = 10;
export const EVENT_CONFIRMATION_GRACE_PERIOD_MINUTES = 60;
export const EVENT_CONFIRMATION_SAFE_WORD = 'CONFIRMAR';
export const SCHEDULE_STORAGE_KEY = 'schedule:lastUpdate';
